module.exports = __webpack_public_path__ + "img/Logo_Projeto_R_Audio.9f811c4b.png";